/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerTerms } from '../../models/customer-terms';

export interface FindTermsAndConditions$Params {
  language: 'de' | 'fr' | 'it';
}

export function findTermsAndConditions(http: HttpClient, rootUrl: string, params: FindTermsAndConditions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerTerms>>> {
  const rb = new RequestBuilder(rootUrl, findTermsAndConditions.PATH, 'get');
  if (params) {
    rb.path('language', params.language, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerTerms>>;
    })
  );
}

findTermsAndConditions.PATH = '/api/customers/{language}/terms-conditions';
